import React from "react";
import { Create, Edit, TextField } from "admin-on-rest";
import IconTitle from "../../components/icon_title";
import TransferCreateForm from "./TransferCreateForm";
import TransferEditForm from "./TransferEditForm";
import { ReferenceField } from "admin-on-rest";

const FullNameField = ({ record = {} }) => (
  <span>
    {record.first_name} {record.last_name}
  </span>
);
FullNameField.defaultProps = { label: "" };

const BalanceField = ({ record = {} }) => {
  const balance =
    record.custom2 && record.custom2.balance ? record.custom2.balance : "0";
  return <span>{balance}</span>;
};

export const TransferCreate = props => (
  <Create
    {...props}
    title={
      <IconTitle
        icon="transfers"
        title={"resources.marketers.transfers.title"}
      />
    }
  >
    <TransferCreateForm {...props} redirect="list" />
  </Create>
);

export const TransferEdit = props => {
  return (
    <Edit
      {...props}
      title={
        <IconTitle
          icon="transfers"
          title={"resources.marketers.transfers.title"}
        />
      }
    >
      <TransferEditForm {...props} redirect="list">
        <ReferenceField
          label="resources.marketers.transfers.fields.marketer"
          source="user_id"
          reference="marketers"
          linkType="show"
        >
          <FullNameField source="last_name" />
        </ReferenceField>
        <ReferenceField
          label="resources.marketers.transfers.fields.bank"
          source="user_id"
          reference="marketers"
          linkType={false}
        >
          <TextField source="custom1.bank" />
        </ReferenceField>
        <ReferenceField
          label="resources.marketers.transfers.fields.bank_account"
          source="user_id"
          reference="marketers"
          linkType={false}
        >
          <TextField source="custom1.account" />
        </ReferenceField>
        <ReferenceField
          label="resources.marketers.transfers.fields.balance"
          source="user_id"
          reference="marketers"
          linkType={false}
        >
          <BalanceField source="custom2.balance" />
        </ReferenceField>
        <TextField
          label="resources.marketers.transfers.fields.amount"
          source="amount"
        />
      </TransferEditForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/marketers/transfers/Create.js